import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Approach } from './components/Approach';
import { Services } from './components/Services';
import { Results } from './components/Results';
import { Method } from './components/Method';
import { About } from './components/About';
import { CTA } from './components/CTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full bg-cream" data-id="element-0" data-mp="2rl6un4aq0ot8">
      <Header data-id="element-1" data-mp="2mm2mmgzj8x4h" />
      <main data-id="element-2" data-mp="2mmcc83go129n">
        <Hero data-id="element-3" data-mp="2mmvlkvs92ic2" />
        <Approach data-id="element-4" data-mp="2mn5f2tci77mi" />
        <Services data-id="element-5" data-mp="2mjpuxc3z38e8" />
        <Results data-id="element-6" data-mp="31aqdwb2cikom" />
        <Method data-id="element-7" data-mp="31b8j3x6zk98o" />
        <About data-id="element-8" data-mp="31bs2licab5ot" />
        <CTA data-id="element-9" data-mp="31bi7xhgaoacs" />
      </main>
      <Footer data-id="element-10" data-mp="31ctf7r8y808n" />
    </div>;
}